// German translations
const de = {
  // Placeholder structure to prevent errors
  navigation: {
    tracking: "Sendungsverfolgung",
    search: "Suche",
    login: "meinMSC",
    language: "Sprache"
  },
  
  menu: {
    solutions: "Lösungen",
    industries: "Branchen",
    ebusiness: "eGeschäft",
    sustainability: "Nachhaltigkeit",
    aboutUs: "Über Uns",
    schedules: "Fahrpläne"
  },
  
  hero: {
    leaderIn: "MARKTFÜHRER IN",
    shippingLogistics: "SCHIFFFAHRT & LOGISTIK",
    trackingTab: "SENDUNGSVERFOLGUNG",
    schedulesTab: "FAHRPLÄNE",
    contactsTab: "KONTAKTE",
    containerBol: "Container / Frachtbrief Nummer",
    bookingNumber: "Buchungsnummer",
    searchPlaceholder: "Suche nach unseren Dienstleistungen und Lösungen...",
    searchButton: "Suchen"
  },
  
  // Default fallback for other sections
  example: {},
  services: {},
  stats: {
    title: "Globale Reichweite, Lokale Expertise",
    description: "Mit einem robusten globalen Netzwerk und tiefgehendem lokalen Wissen verbinden wir Unternehmen über Kontinente hinweg.",
    years: "Jahre Erfahrung",
    countries: "Bediente Länder",
    clients: "Aktive Kunden",
    shipments: "Jährliche Sendungen"
  },
  industries: {},
  footer: {}
};

export default de; 